import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.scss';

const Icons = (props) => {
  const { className, variant, onClick, testid, color } = props;

  const getIcons = () => {
    switch (variant) {
      case Icons.PEOPLE: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#FF576D" />
            <path
              d="M9.44955 10.1603C9.44955 9.53526 9.6349 8.92424 9.98216 8.40453C10.3294 7.88482 10.823 7.47976 11.4005 7.24056C11.9779 7.00137 12.6134 6.93878 13.2264 7.06073C13.8394 7.18267 14.4026 7.48366 14.8445 7.92564C15.2865 8.36761 15.5875 8.93073 15.7094 9.54377C15.8314 10.1568 15.7688 10.7922 15.5296 11.3697C15.2904 11.9472 14.8853 12.4408 14.3656 12.788C13.8459 13.1353 13.2349 13.3206 12.6099 13.3206C12.1948 13.3206 11.7839 13.2389 11.4005 13.0801C11.017 12.9212 10.6686 12.6885 10.3752 12.395C10.0817 12.1015 9.84893 11.7531 9.69011 11.3697C9.53129 10.9863 9.44955 10.5753 9.44955 10.1603ZM25 23.5173C25 20.8815 22.3368 18.7447 19.0515 18.7447C15.7663 18.7447 13.103 20.8815 13.103 23.5173C13.103 24.5058 16.0773 25 19.0515 25C22.0258 25 25 24.5058 25 23.5173ZM12.6099 20.2031C12.9972 20.2031 13.3842 20.1939 13.7641 20.1761C14.7984 19.1086 16.1472 18.4003 17.6132 18.1548C16.9015 17.8852 16.2795 17.4217 15.8177 16.8169C15.3558 16.212 15.0725 15.4899 14.9998 14.7324C14.2356 14.4464 13.4258 14.3012 12.6099 14.3038C9.51162 14.3038 7 16.319 7 18.8048C7 19.737 9.80493 20.2031 12.6099 20.2031ZM19.0515 17.7021C19.7143 17.7021 20.3622 17.5056 20.9133 17.1374C21.4643 16.7691 21.8939 16.2458 22.1475 15.6334C22.4011 15.0211 22.4675 14.3473 22.3382 13.6973C22.2089 13.0473 21.8897 12.4502 21.4211 11.9815C20.9524 11.5128 20.3553 11.1937 19.7053 11.0644C19.0552 10.9351 18.3814 11.0015 17.7691 11.2551C17.1568 11.5087 16.6334 11.9382 16.2652 12.4893C15.897 13.0404 15.7004 13.6883 15.7004 14.3511C15.7004 14.7911 15.7871 15.2269 15.9555 15.6335C16.1239 16.04 16.3708 16.4095 16.682 16.7206C16.9931 17.0318 17.3626 17.2786 17.7691 17.447C18.1757 17.6155 18.6115 17.7021 19.0515 17.7021Z"
              fill="white"
            />
          </svg>
        );
      }
      case Icons.PLUS: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="16" height="16" fill="none" />
            <path
              d="M8 3.33398V12.6673"
              stroke={color ?? '#303030'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.33203 8H12.6654"
              stroke={color ?? '#303030'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.PLUS_BG: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#e5e5e5" />
            <path d="M11 16H21" stroke="#252D44" strokeWidth="2" strokeLinecap="round" />
            <path d="M16 21L16 11" stroke="#252D44" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      }
      case Icons.TIMELINE: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#FF576D" />
            <path
              d="M9.44955 10.1603C9.44955 9.53526 9.6349 8.92424 9.98216 8.40453C10.3294 7.88482 10.823 7.47976 11.4005 7.24056C11.9779 7.00137 12.6134 6.93878 13.2264 7.06073C13.8394 7.18267 14.4026 7.48366 14.8445 7.92564C15.2865 8.36761 15.5875 8.93073 15.7094 9.54377C15.8314 10.1568 15.7688 10.7922 15.5296 11.3697C15.2904 11.9472 14.8853 12.4408 14.3656 12.788C13.8459 13.1353 13.2349 13.3206 12.6099 13.3206C12.1948 13.3206 11.7839 13.2389 11.4005 13.0801C11.017 12.9212 10.6686 12.6885 10.3752 12.395C10.0817 12.1015 9.84893 11.7531 9.69011 11.3697C9.53129 10.9863 9.44955 10.5753 9.44955 10.1603ZM25 23.5173C25 20.8815 22.3368 18.7447 19.0515 18.7447C15.7663 18.7447 13.103 20.8815 13.103 23.5173C13.103 24.5058 16.0773 25 19.0515 25C22.0258 25 25 24.5058 25 23.5173ZM12.6099 20.2031C12.9972 20.2031 13.3842 20.1939 13.7641 20.1761C14.7984 19.1086 16.1472 18.4003 17.6132 18.1548C16.9015 17.8852 16.2795 17.4217 15.8177 16.8169C15.3558 16.212 15.0725 15.4899 14.9998 14.7324C14.2356 14.4464 13.4258 14.3012 12.6099 14.3038C9.51162 14.3038 7 16.319 7 18.8048C7 19.737 9.80493 20.2031 12.6099 20.2031ZM19.0515 17.7021C19.7143 17.7021 20.3622 17.5056 20.9133 17.1374C21.4643 16.7691 21.8939 16.2458 22.1475 15.6334C22.4011 15.0211 22.4675 14.3473 22.3382 13.6973C22.2089 13.0473 21.8897 12.4502 21.4211 11.9815C20.9524 11.5128 20.3553 11.1937 19.7053 11.0644C19.0552 10.9351 18.3814 11.0015 17.7691 11.2551C17.1568 11.5087 16.6334 11.9382 16.2652 12.4893C15.897 13.0404 15.7004 13.6883 15.7004 14.3511C15.7004 14.7911 15.7871 15.2269 15.9555 15.6335C16.1239 16.04 16.3708 16.4095 16.682 16.7206C16.9931 17.0318 17.3626 17.2786 17.7691 17.447C18.1757 17.6155 18.6115 17.7021 19.0515 17.7021Z"
              fill="white"
            />
          </svg>
        );
      }
      case Icons.EDIT: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.33203 16.6663H6.66536L15.4154 7.91627C15.8574 7.47424 16.1057 6.87472 16.1057 6.2496C16.1057 5.62448 15.8574 5.02496 15.4154 4.58293C14.9733 4.14091 14.3738 3.89258 13.7487 3.89258C13.1236 3.89258 12.5241 4.14091 12.082 4.58293L3.33203 13.3329V16.6663Z"
              stroke={color ?? '#303030'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.25 5.41797L14.5833 8.7513"
              stroke={color ?? '#303030'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.CHECKMARK: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.33203 7.99935L6.66536 11.3327L13.332 4.66602"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.ARROW_BOTTOM: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 6L8 10L4 6"
              stroke="#303030"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.CLOSE: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8 16L16 8" stroke="#163C5A" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M16 16L8 8" stroke="#163C5A" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        );
      }
      case Icons.HOUSE_SMALL: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#252D44" />
            <path
              d="M9 24H8C8 24.5523 8.44772 25 9 25V24ZM10 14C10 13.4477 9.55228 13 9 13C8.44772 13 8 13.4477 8 14H10ZM23 24V25C23.5523 25 24 24.5523 24 24H23ZM24 14C24 13.4477 23.5523 13 23 13C22.4477 13 22 13.4477 22 14H24ZM10 24V14H8V24H10ZM9 25H23V23H9V25ZM24 24V14H22V24H24Z"
              fill="white"
            />
            <path
              d="M13 24C13 24.5523 13.4477 25 14 25C14.5523 25 15 24.5523 15 24H13ZM14 18V17C13.4477 17 13 17.4477 13 18H14ZM18 18H19C19 17.4477 18.5523 17 18 17V18ZM17 24C17 24.5523 17.4477 25 18 25C18.5523 25 19 24.5523 19 24H17ZM15 24V18H13V24H15ZM14 19H18V17H14V19ZM17 18V24H19V18H17Z"
              fill="white"
            />
            <path
              d="M7.36941 13.7239C6.94077 14.0722 6.87562 14.702 7.22389 15.1306C7.57215 15.5592 8.20196 15.6244 8.63059 15.2761L7.36941 13.7239ZM16 8L16.6306 7.22389C16.2632 6.92537 15.7368 6.92537 15.3694 7.22389L16 8ZM19.7482 8V7C19.1959 7 18.7482 7.44772 18.7482 8H19.7482ZM23 8H24C24 7.44772 23.5523 7 23 7V8ZM23.3694 15.2761C23.798 15.6244 24.4278 15.5592 24.7761 15.1306C25.1244 14.702 25.0592 14.0722 24.6306 13.7239L23.3694 15.2761ZM18.7482 11C18.7482 11.5523 19.1959 12 19.7482 12C20.3005 12 20.7482 11.5523 20.7482 11H18.7482ZM8.63059 15.2761L16.6306 8.77611L15.3694 7.22389L7.36941 13.7239L8.63059 15.2761ZM19.7482 9H23V7H19.7482V9ZM18.7482 8V11H20.7482V8H18.7482ZM15.3694 8.77611L22.3694 14.4636L23.6306 12.9114L16.6306 7.22389L15.3694 8.77611ZM22.3694 14.4636L23.3694 15.2761L24.6306 13.7239L23.6306 12.9114L22.3694 14.4636ZM22 8V13.6875H24V8H22Z"
              fill="white"
            />
          </svg>
        );
      }
      case Icons.OFFERS: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 9H10"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 13H15"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 17H15"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.MEGAPHONE: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.1363 2.50059C12.3556 4.33901 8.74472 6.80982 2.94961 8.28897C2.14692 8.49385 1.62821 9.28708 1.80045 10.0974L2.00836 11.0755C2.1806 11.8859 2.9771 12.3995 3.79373 12.2602C9.68945 11.2544 13.9931 12.0429 15.454 13.4049C15.858 13.7815 16.4097 14.1485 16.9499 14.0337C17.4901 13.9188 17.835 13.3878 17.7201 12.8476L15.4331 2.08799C15.3183 1.54777 14.7873 1.20293 14.247 1.31775C13.7068 1.43258 13.3521 1.99224 13.1363 2.50059Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M5.35864 12.4082L8.30714 17.705C8.52066 18.0886 8.95939 18.2881 9.3888 18.1968L10.2764 18.0081C10.9345 17.8682 11.2695 17.1314 10.9423 16.5436L8.29309 11.7845"
              stroke="#262626"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case Icons.SETTINGS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" r="2.5" stroke="#262626" strokeWidth="2" />
            <path
              d="M3.1298 10.2598L3.96431 10.8108C4.07923 10.6368 4.13685 10.4311 4.12911 10.2227L3.1298 10.2598ZM3.1298 9.74018L4.12911 9.77731C4.13685 9.56888 4.07923 9.36324 3.96431 9.18919L3.1298 9.74018ZM1.91047 7.89343L2.74499 7.34244L2.74499 7.34244L1.91047 7.89343ZM1.87108 6.57969L2.73711 7.07969H2.73711L1.87108 6.57969ZM2.97354 4.67018L2.10751 4.17018L2.10751 4.17018L2.97354 4.67018ZM4.13097 4.04742L4.07105 5.04563H4.07105L4.13097 4.04742ZM6.33872 4.17994L6.2788 5.17814C6.48759 5.19067 6.69505 5.13742 6.872 5.02588L6.33872 4.17994ZM6.79097 3.91831L7.2584 4.80235C7.44281 4.70484 7.59211 4.55211 7.6854 4.36553L6.79097 3.91831ZM7.77964 1.94098L8.67407 2.3882V2.3882L7.77964 1.94098ZM12.2206 1.94098L13.115 1.49377V1.49377L12.2206 1.94098ZM13.2094 3.91853L12.315 4.36575C12.4082 4.5523 12.5575 4.70503 12.7419 4.80253L13.2094 3.91853ZM13.6615 4.18007L13.1281 5.02599C13.3051 5.13755 13.5126 5.19081 13.7214 5.17827L13.6615 4.18007ZM15.8691 4.04756L15.8092 3.04935L15.8691 4.04756ZM17.0266 4.67031L16.1605 5.17031V5.17031L17.0266 4.67031ZM18.129 6.57982L18.9951 6.07982L18.129 6.57982ZM18.0896 7.89356L18.9241 8.44455L18.9241 8.44455L18.0896 7.89356ZM16.8702 9.74052L16.0357 9.18953C15.9207 9.36357 15.8631 9.56919 15.8709 9.7776L16.8702 9.74052ZM16.8702 10.2595L15.8709 10.2224C15.8631 10.4308 15.9207 10.6364 16.0357 10.8105L16.8702 10.2595ZM18.0896 12.1064L18.9241 11.5555L18.9241 11.5554L18.0896 12.1064ZM18.129 13.4202L18.9951 13.9202L18.9951 13.9202L18.129 13.4202ZM17.0266 15.3297L16.1605 14.8297V14.8297L17.0266 15.3297ZM15.8691 15.9524L15.9291 14.9542H15.9291L15.8691 15.9524ZM13.6614 15.8199L13.7214 14.8217C13.5126 14.8092 13.3051 14.8625 13.1281 14.974L13.6614 15.8199ZM13.2094 16.0815L12.7419 15.1975C12.5575 15.295 12.4082 15.4477 12.315 15.6343L13.2094 16.0815ZM12.2206 18.059L13.115 18.5062L13.115 18.5062L12.2206 18.059ZM7.77964 18.059L8.67407 17.6118L8.67407 17.6118L7.77964 18.059ZM6.79097 16.0817L7.6854 15.6345C7.59211 15.4479 7.44281 15.2952 7.2584 15.1977L6.79097 16.0817ZM6.33871 15.8201L6.87199 14.9741C6.69505 14.8626 6.48759 14.8093 6.2788 14.8219L6.33871 15.8201ZM4.13097 15.9526L4.07105 14.9544H4.07105L4.13097 15.9526ZM2.97354 15.3298L2.10751 15.8298H2.10751L2.97354 15.3298ZM1.87108 13.4203L1.00506 13.9203H1.00506L1.87108 13.4203ZM1.91047 12.1066L2.74499 12.6576H2.74499L1.91047 12.1066ZM4.12911 10.2227C4.12636 10.1488 4.12498 10.0746 4.12498 10H2.12498C2.12498 10.0994 2.12682 10.1984 2.13049 10.297L4.12911 10.2227ZM4.12498 10C4.12498 9.92539 4.12636 9.85115 4.12911 9.77731L2.13049 9.70304C2.12682 9.80162 2.12498 9.90062 2.12498 10H4.12498ZM3.96431 9.18919L2.74499 7.34244L1.07596 8.44442L2.29529 10.2912L3.96431 9.18919ZM2.74499 7.34244C2.69281 7.26341 2.68976 7.1617 2.73711 7.07969L1.00506 6.07969C0.578938 6.81775 0.606388 7.73321 1.07596 8.44442L2.74499 7.34244ZM2.73711 7.07969L3.83957 5.17018L2.10751 4.17018L1.00506 6.07969L2.73711 7.07969ZM3.83957 5.17018C3.88691 5.08817 3.97653 5.03995 4.07105 5.04563L4.19088 3.04922C3.34017 2.99816 2.53363 3.43212 2.10751 4.17018L3.83957 5.17018ZM4.07105 5.04563L6.2788 5.17814L6.39863 3.18173L4.19088 3.04922L4.07105 5.04563ZM6.872 5.02588C6.9977 4.94663 7.12658 4.87204 7.2584 4.80235L6.32355 3.03428C6.14671 3.12778 5.9739 3.2278 5.80543 3.334L6.872 5.02588ZM7.6854 4.36553L8.67407 2.3882L6.88521 1.49377L5.89655 3.4711L7.6854 4.36553ZM8.67407 2.3882C8.71641 2.3035 8.80298 2.25 8.89767 2.25V0.25C8.04544 0.25 7.26634 0.731505 6.88521 1.49377L8.67407 2.3882ZM8.89767 2.25H11.1026V0.25H8.89767V2.25ZM11.1026 2.25C11.1973 2.25 11.2838 2.3035 11.3262 2.3882L13.115 1.49377C12.7339 0.731505 11.9548 0.25 11.1026 0.25V2.25ZM11.3262 2.3882L12.315 4.36575L14.1038 3.47132L13.115 1.49377L11.3262 2.3882ZM12.7419 4.80253C12.8737 4.87221 13.0025 4.94677 13.1281 5.02599L14.1948 3.33415C14.0264 3.22799 13.8536 3.12801 13.6769 3.03453L12.7419 4.80253ZM13.7214 5.17827L15.9291 5.04576L15.8092 3.04935L13.6015 3.18187L13.7214 5.17827ZM15.9291 5.04576C16.0236 5.04009 16.1132 5.0883 16.1605 5.17031L17.8926 4.17031C17.4665 3.43225 16.6599 2.99829 15.8092 3.04935L15.9291 5.04576ZM16.1605 5.17031L17.263 7.07982L18.9951 6.07982L17.8926 4.17031L16.1605 5.17031ZM17.263 7.07982C17.3103 7.16183 17.3073 7.26355 17.2551 7.34257L18.9241 8.44455C19.3937 7.73335 19.4212 6.81788 18.9951 6.07982L17.263 7.07982ZM17.2551 7.34257L16.0357 9.18953L17.7047 10.2915L18.9241 8.44455L17.2551 7.34257ZM15.8709 9.7776C15.8736 9.85135 15.875 9.92549 15.875 10H17.875C17.875 9.90075 17.8731 9.80189 17.8695 9.70344L15.8709 9.7776ZM15.875 10C15.875 10.0745 15.8736 10.1486 15.8709 10.2224L17.8695 10.2966C17.8731 10.1981 17.875 10.0992 17.875 10H15.875ZM16.0357 10.8105L17.2551 12.6574L18.9241 11.5554L17.7047 9.70849L16.0357 10.8105ZM17.2551 12.6574C17.3073 12.7365 17.3103 12.8382 17.263 12.9202L18.9951 13.9202C19.4212 13.1821 19.3937 12.2667 18.9241 11.5555L17.2551 12.6574ZM17.263 12.9202L16.1605 14.8297L17.8926 15.8297L18.9951 13.9202L17.263 12.9202ZM16.1605 14.8297C16.1132 14.9117 16.0236 14.9599 15.9291 14.9542L15.8092 16.9506C16.6599 17.0017 17.4665 16.5677 17.8926 15.8297L16.1605 14.8297ZM15.9291 14.9542L13.7214 14.8217L13.6015 16.8181L15.8092 16.9506L15.9291 14.9542ZM13.1281 14.974C13.0025 15.0532 12.8737 15.1278 12.7419 15.1975L13.6769 16.9655C13.8536 16.872 14.0264 16.772 14.1948 16.6659L13.1281 14.974ZM12.315 15.6343L11.3262 17.6118L13.115 18.5062L14.1038 16.5287L12.315 15.6343ZM11.3262 17.6118C11.2838 17.6965 11.1973 17.75 11.1026 17.75V19.75C11.9548 19.75 12.7339 19.2685 13.115 18.5062L11.3262 17.6118ZM11.1026 17.75H8.89767V19.75H11.1026V17.75ZM8.89767 17.75C8.80298 17.75 8.71641 17.6965 8.67407 17.6118L6.88521 18.5062C7.26634 19.2685 8.04544 19.75 8.89767 19.75V17.75ZM8.67407 17.6118L7.6854 15.6345L5.89655 16.5289L6.88521 18.5062L8.67407 17.6118ZM7.2584 15.1977C7.12658 15.128 6.9977 15.0534 6.87199 14.9741L5.80544 16.666C5.9739 16.7722 6.14671 16.8722 6.32355 16.9657L7.2584 15.1977ZM6.2788 14.8219L4.07105 14.9544L4.19088 16.9508L6.39863 16.8183L6.2788 14.8219ZM4.07105 14.9544C3.97653 14.96 3.88691 14.9118 3.83957 14.8298L2.10751 15.8298C2.53363 16.5679 3.34017 17.0018 4.19088 16.9508L4.07105 14.9544ZM3.83957 14.8298L2.73711 12.9203L1.00506 13.9203L2.10751 15.8298L3.83957 14.8298ZM2.73711 12.9203C2.68976 12.8383 2.69281 12.7366 2.74499 12.6576L1.07596 11.5556C0.606388 12.2668 0.578939 13.1823 1.00506 13.9203L2.73711 12.9203ZM2.74499 12.6576L3.96431 10.8108L2.29529 9.70883L1.07596 11.5556L2.74499 12.6576Z"
              fill="#262626"
            />
          </svg>
        );
      }
      case Icons.ARROW_RIGHT: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 4L10 8L6 12"
              stroke="#515151"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.OVERDUE_TASKS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <g clipPath="url(#clip0_38195_26496)">
                <path
                  d="M2.91663 4.58333L4.16663 5.83333L6.24996 3.75"
                  stroke="#EC455E"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.91663 9.58333L4.16663 10.8333L6.24996 8.75"
                  stroke="#EC455E"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.91663 14.5833L4.16663 15.8333L6.24996 13.75"
                  stroke="#EC455E"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.16663 5H16.6666"
                  stroke="#EC455E"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.16663 10H16.6666"
                  stroke="#EC455E"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.16663 15H16.6666"
                  stroke="#EC455E"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_38195_26496">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.TASKS_DUE_TODAY: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <g clipPath="url(#clip0_38195_26496)">
                <path
                  d="M2.91663 4.58333L4.16663 5.83333L6.24996 3.75"
                  stroke="#FB913A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.91663 9.58333L4.16663 10.8333L6.24996 8.75"
                  stroke="#FB913A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.91663 14.5833L4.16663 15.8333L6.24996 13.75"
                  stroke="#FB913A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.16663 5H16.6666"
                  stroke="#FB913A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.16663 10H16.6666"
                  stroke="#FB913A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.16663 15H16.6666"
                  stroke="#FB913A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_38195_26496">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.EXPIRING_OFFERS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M11.6666 2.5V5.83333C11.6666 6.05435 11.7544 6.26631 11.9107 6.42259C12.067 6.57887 12.2789 6.66667 12.5 6.66667H15.8333"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.99996 17.5H5.83329C5.39127 17.5 4.96734 17.3244 4.65478 17.0118C4.34222 16.6993 4.16663 16.2754 4.16663 15.8333V4.16667C4.16663 3.72464 4.34222 3.30072 4.65478 2.98816C4.96734 2.67559 5.39127 2.5 5.83329 2.5H11.6666L15.8333 6.66667V9"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="14" cy="14" r="5" stroke="#EC455E" strokeWidth="2" />
              <path
                d="M14 12V13.5"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="14" cy="16" r="1" fill="#EC455E" />
            </g>
          </svg>
        );
      }
      case Icons.NEW_OFFERS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M11.6666 2.5V5.83333C11.6666 6.05435 11.7544 6.26631 11.9107 6.42259C12.067 6.57887 12.2789 6.66667 12.5 6.66667H15.8333"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.1666 17.5H5.83329C5.39127 17.5 4.96734 17.3244 4.65478 17.0118C4.34222 16.6993 4.16663 16.2754 4.16663 15.8333V4.16667C4.16663 3.72464 4.34222 3.30072 4.65478 2.98816C4.96734 2.67559 5.39127 2.5 5.83329 2.5H11.6666L15.8333 6.66667V15.8333C15.8333 16.2754 15.6577 16.6993 15.3451 17.0118C15.0326 17.3244 14.6087 17.5 14.1666 17.5Z"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );
      }
      case Icons.PENDING_OFFERS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M11.6666 2.5V5.83333C11.6666 6.05435 11.7544 6.26631 11.9107 6.42259C12.067 6.57887 12.2789 6.66667 12.5 6.66667H15.8333"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.99996 17.5H5.83329C5.39127 17.5 4.96734 17.3244 4.65478 17.0118C4.34222 16.6993 4.16663 16.2754 4.16663 15.8333V4.16667C4.16663 3.72464 4.34222 3.30072 4.65478 2.98816C4.96734 2.67559 5.39127 2.5 5.83329 2.5H11.6666L15.8333 6.66667V9"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="14" cy="14" r="5" stroke="#FB913A" strokeWidth="2" />
              <path
                d="M14 12V14L15.5 15"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );
      }
      case Icons.PENDING_SHOWINGS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M9.5 16.4815H5.14002C4.24532 16.4815 3.52002 15.7562 3.52002 14.8615V5.14149C3.52002 4.24678 4.24532 3.52148 5.14002 3.52148H14.86C15.7547 3.52148 16.48 4.24678 16.48 5.14149V9"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.24 2.43945V4.59945"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.76001 2.43945V4.59945"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.52002 7.83984H16.48"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="14" cy="14" r="5" stroke="#FB913A" strokeWidth="2" />
              <path
                d="M14 12V14L15.5 15"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );
      }
      case Icons.UPCOMING_SHOWINGS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M14.86 3.52148H5.14002C4.24532 3.52148 3.52002 4.24678 3.52002 5.14149V14.8615C3.52002 15.7562 4.24532 16.4815 5.14002 16.4815H14.86C15.7547 16.4815 16.48 15.7562 16.48 14.8615V5.14149C16.48 4.24678 15.7547 3.52148 14.86 3.52148Z"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.24 2.43945V4.59945"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.76001 2.43945V4.59945"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.52002 7.83984H16.48"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );
      }
      case Icons.NEW_SHOWINGS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8" clipPath="url(#clip0_38202_54206)">
              <path
                d="M3.33337 17.4993V6.66602C3.33337 6.00297 3.59677 5.36709 4.06561 4.89825C4.53445 4.42941 5.17033 4.16602 5.83337 4.16602H14.1667C14.8298 4.16602 15.4656 4.42941 15.9345 4.89825C16.4033 5.36709 16.6667 6.00297 16.6667 6.66602V11.666C16.6667 12.3291 16.4033 12.9649 15.9345 13.4338C15.4656 13.9026 14.8298 14.166 14.1667 14.166H6.66671L3.33337 17.4993Z"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 7.08398V8.75065"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="9.99996" cy="11.2493" r="0.833333" fill="#FB913A" />
            </g>
            <defs>
              <clipPath id="clip0_38202_54206">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.PANEL_CLOSE: {
        return (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="40" height="40" rx="20" fill="#F4F5F6" />
            <path d="M25 25L15 15" stroke="#262626" strokeWidth="2" strokeLinecap="round" />
            <path d="M15 25L25 15" stroke="#262626" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      }
      case Icons.LOCK: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_38348_17825)">
              <path
                d="M14.166 9.16602H5.83268C4.91221 9.16602 4.16602 9.91221 4.16602 10.8327V15.8327C4.16602 16.7532 4.91221 17.4993 5.83268 17.4993H14.166C15.0865 17.4993 15.8327 16.7532 15.8327 15.8327V10.8327C15.8327 9.91221 15.0865 9.16602 14.166 9.16602Z"
                stroke={color ?? '#747475'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.99935 14.1667C10.4596 14.1667 10.8327 13.7936 10.8327 13.3333C10.8327 12.8731 10.4596 12.5 9.99935 12.5C9.53911 12.5 9.16602 12.8731 9.16602 13.3333C9.16602 13.7936 9.53911 14.1667 9.99935 14.1667Z"
                stroke={color ?? '#747475'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.66602 9.16667V5.83333C6.66602 4.94928 7.0172 4.10143 7.64233 3.47631C8.26745 2.85119 9.11529 2.5 9.99935 2.5C10.8834 2.5 11.7313 2.85119 12.3564 3.47631C12.9815 4.10143 13.3327 4.94928 13.3327 5.83333V9.16667"
                stroke={color ?? '#747475'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_38348_17825">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.SHARED: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_38348_17737)">
              <path
                d="M11.75 7.25H4.25C3.42157 7.25 2.75 7.92157 2.75 8.75V13.25C2.75 14.0784 3.42157 14.75 4.25 14.75H11.75C12.5784 14.75 13.25 14.0784 13.25 13.25V8.75C13.25 7.92157 12.5784 7.25 11.75 7.25Z"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 11.75C8.41421 11.75 8.75 11.4142 8.75 11C8.75 10.5858 8.41421 10.25 8 10.25C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75Z"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 7.25V4.25C5 3.45435 5.31607 2.69129 5.87868 2.12868C6.44129 1.56607 7.20435 1.25 8 1.25C8.79565 1.25 9.55871 1.56607 10.1213 2.12868C10.6839 2.69129 11 3.45435 11 4.25"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_38348_17737">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.TAGGED_COMMENTS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M3.80225 13.6888L4.72232 14.0806L4.9202 13.6159L4.66358 13.1808L3.80225 13.6888ZM2.35238 17.094L1.43231 16.7023H1.43231L2.35238 17.094ZM2.99238 17.7564L3.3523 18.6894H3.3523L2.99238 17.7564ZM6.57083 16.3759L7.05279 15.4997L6.64507 15.2755L6.21091 15.4429L6.57083 16.3759ZM16.3437 9.99929C16.3437 13.4636 13.5353 16.272 10.071 16.272V18.272C14.6399 18.272 18.3437 14.5682 18.3437 9.99929H16.3437ZM10.071 3.72656C13.5353 3.72656 16.3437 6.53496 16.3437 9.99929H18.3437C18.3437 5.43039 14.6399 1.72656 10.071 1.72656V3.72656ZM3.79823 9.99929C3.79823 6.53496 6.60662 3.72656 10.071 3.72656V1.72656C5.50205 1.72656 1.79823 5.43039 1.79823 9.99929H3.79823ZM4.66358 13.1808C4.11388 12.2488 3.79823 11.1624 3.79823 9.99929H1.79823C1.79823 11.5295 2.21463 12.9655 2.94092 14.1969L4.66358 13.1808ZM3.27245 17.4858L4.72232 14.0806L2.88218 13.2971L1.43231 16.7023L3.27245 17.4858ZM2.63246 16.8234C3.04476 16.6644 3.44558 17.0792 3.27245 17.4858L1.43231 16.7023C0.912943 17.9221 2.11539 19.1665 3.3523 18.6894L2.63246 16.8234ZM6.21091 15.4429L2.63246 16.8234L3.3523 18.6894L6.93075 17.3089L6.21091 15.4429ZM10.071 16.272C8.97488 16.272 7.94726 15.9917 7.05279 15.4997L6.08887 17.2521C7.27115 17.9024 8.62939 18.272 10.071 18.272V16.272Z"
                fill="#FB913A"
              />
            </g>
          </svg>
        );
      }
      case Icons.OPTIONS: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="9" cy="16" r="2" fill="#747475" />
            <circle cx="16" cy="16" r="2" fill="#747475" />
            <circle cx="23" cy="16" r="2" fill="#747475" />
          </svg>
        );
      }
      case Icons.DELETE: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_38348_17771)">
              <path
                d="M2.00195 4.25H14.002"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.50195 7.25V11.75"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.49805 7.25V11.75"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2.74805 4.25L3.49805 13.25C3.49805 13.6478 3.65608 14.0294 3.93739 14.3107C4.21869 14.592 4.60022 14.75 4.99805 14.75H10.998C11.3959 14.75 11.7774 14.592 12.0587 14.3107C12.34 14.0294 12.498 13.6478 12.498 13.25L13.248 4.25"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.75 4.25V2C5.75 1.80109 5.82902 1.61032 5.96967 1.46967C6.11032 1.32902 6.30109 1.25 6.5 1.25H9.5C9.69891 1.25 9.88968 1.32902 10.0303 1.46967C10.171 1.61032 10.25 1.80109 10.25 2V4.25"
                stroke="#FF576D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_38348_17771">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.USER: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.3327 4.66732C11.3327 6.50827 9.8403 8.00065 7.99935 8.00065C6.1584 8.00065 4.66602 6.50827 4.66602 4.66732C4.66602 2.82637 6.1584 1.33398 7.99935 1.33398C9.8403 1.33398 11.3327 2.82637 11.3327 4.66732Z"
              stroke="#FF576D"
              strokeWidth="2"
            />
            <path
              d="M2.66602 13.9993C2.99841 12.2187 4.5266 10.666 6.22146 10.666H9.77713C11.472 10.666 13.0003 12.2187 13.3327 13.9993"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.NEW_NOTES: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M14.5454 9.09073V15.3029C14.5454 15.7047 14.3858 16.0901 14.1016 16.3742C13.8175 16.6584 13.4321 16.818 13.0302 16.818H4.69691C4.29507 16.818 3.90969 16.6584 3.62554 16.3742C3.34139 16.0901 3.18176 15.7047 3.18176 15.3029V4.69679C3.18176 4.29495 3.34139 3.90956 3.62554 3.62542C3.90969 3.34127 4.29507 3.18164 4.69691 3.18164H10.909L12.4242 4.69679"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.27271 12.7275H10.1195L17.5922 5.2547C17.9697 4.8772 18.1818 4.36519 18.1818 3.83132C18.1818 3.29745 17.9697 2.78545 17.5922 2.40794C17.2147 2.03044 16.7027 1.81836 16.1688 1.81836C15.635 1.81836 15.123 2.03044 14.7455 2.40794L7.27271 9.88069V12.7275Z"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.0341 3.11914L16.8808 5.9659"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );
      }
      case Icons.INVITE_TO_TRANSACTION: {
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="28" cy="28" r="28" fill="#F4F5F6" />
            <path
              d="M29.75 22.75C29.75 25.6495 27.3995 28 24.5 28C21.6005 28 19.25 25.6495 19.25 22.75C19.25 19.8505 21.6005 17.5 24.5 17.5C27.3995 17.5 29.75 19.8505 29.75 22.75Z"
              stroke="#515151"
              strokeWidth="2.5"
            />
            <path
              d="M16.625 38.0625C17.1158 35.258 19.3723 32.8125 21.8748 32.8125H27.125C29.6276 32.8125 31.8842 35.258 32.375 38.0625"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M33.25 28H40.25M36.75 24.5V31.5"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.DELETE_CONTACT: {
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle opacity="0.1" cx="28" cy="28" r="28" fill="#EC455E" />
            <g clipPath="url(#clip0_64498_27351)">
              <path
                d="M17.332 21.334H38.6654"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25.332 26.666V34.666"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M30.668 26.666V34.666"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.668 21.334L20.0013 37.334C20.0013 38.0412 20.2823 38.7195 20.7824 39.2196C21.2824 39.7197 21.9607 40.0007 22.668 40.0007H33.3346C34.0419 40.0007 34.7202 39.7197 35.2203 39.2196C35.7204 38.7195 36.0013 38.0412 36.0013 37.334L37.3346 21.334"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M24 21.3333V17.3333C24 16.9797 24.1405 16.6406 24.3905 16.3905C24.6406 16.1405 24.9797 16 25.3333 16H30.6667C31.0203 16 31.3594 16.1405 31.6095 16.3905C31.8595 16.6406 32 16.9797 32 17.3333V21.3333"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_64498_27351">
                <rect width="32" height="32" fill="white" transform="translate(12 12)" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      default: {
        return null;
      }
    }
  };

  return (
    <div testid={testid} onClick={onClick} className={classNames(styles.icons, className)}>
      {getIcons()}
    </div>
  );
};

Icons.PEOPLE = 'people';
Icons.PLUS = 'plus';
Icons.PLUS_BG = 'plus_bg';
Icons.TIMELINE = 'timeline';
Icons.EDIT = 'edit';
Icons.CHECKMARK = 'checkmark';
Icons.ARROW_BOTTOM = 'arrowBottom';
Icons.CLOSE = 'close';
Icons.HOUSE_SMALL = 'houseSmall';
Icons.MEGAPHONE = 'megaphone';
Icons.SETTINGS = 'settings';
Icons.ARROW_RIGHT = 'arrowRight';
Icons.OFFERS = 'offers';
Icons.OVERDUE_TASKS = 'overdueTasks';
Icons.TASKS_DUE_TODAY = 'tasksDueToday';
Icons.EXPIRING_OFFERS = 'expiringOffers';
Icons.NEW_OFFERS = 'newOffers';
Icons.PENDING_OFFERS = 'pendingOffers';
Icons.NEW_SHOWINGS = 'newShowing';
Icons.UPCOMING_SHOWINGS = 'upcomingShowing';
Icons.PENDING_SHOWINGS = 'pendingShowing';
Icons.TAGGED_COMMENTS = 'taggedComments';
Icons.PANEL_CLOSE = 'panelClose';
Icons.LOCK = 'lock';
Icons.SHARED = 'shared';
Icons.OPTIONS = 'options';
Icons.DELETE = 'delete';
Icons.USER = 'user';
Icons.NEW_NOTES = 'newNotes';
Icons.INVITE_TO_TRANSACTION = 'inviteToTransaction';
Icons.DELETE_CONTACT = 'deleteCircle';

Icons.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  testid: PropTypes.string,
  onClick: PropTypes.func,
};

Icons.defaultProps = {
  className: '',
  variant: '',
  color: undefined,
  testid: undefined,
  onClick: () => {},
};

export default Icons;
